// shop-frontend/src/components/ShopProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useShopAuth } from "../context/ShopAuthContext";

export default function ShopProtectedRoute({ children }) {
  const { loading, isAuthed, shop, loggingOut } = useShopAuth();
  const loc = useLocation();

  // ✅ If logging out, render nothing and let browser redirect handle it
  if (loggingOut) {
    return null;
  }

  // ✅ If user loses auth (e.g., token expired or logout), redirect immediately
  // Removed navigation side-effect to avoid double redirects and navigation loops.
  // Redirect is handled by the render return below using <Navigate /> which is safer.

  // ✅ During refreshMe() don't redirect yet
  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontWeight: 900,
          opacity: 0.85,
        }}
      >
        Loading…
      </div>
    );
  }

  // ✅ Preserve full path (including querystring)
  const from = `${loc.pathname}${loc.search || ""}`;

  // ✅ If no token OR no shop object (extra safety)
  if (!isAuthed || !shop) {
    return <Navigate to="/shop/login" replace state={{ from }} />;
  }

  return children || <Outlet />;
}
